webpackJsonp([171280405282268],{

/***/ 123:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(123);
	
	var _Image = __webpack_require__(17);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconList = function (_Component) {
	  _inherits(IconList, _Component);
	
	  function IconList() {
	    _classCallCheck(this, IconList);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IconList.prototype.render = function render() {
	    var _props$iconList = this.props.iconList,
	        iconList = _props$iconList === undefined ? [] : _props$iconList;
	
	
	    return _react2.default.createElement(
	      'ul',
	      { className: 'icons' },
	      iconList.map(function (list, index) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(_Image2.default, { src: list.icon, alt: list.title }),
	          _react2.default.createElement(
	            'b',
	            null,
	            list.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            list.content
	          )
	        );
	      })
	    );
	  };
	
	  return IconList;
	}(_react.Component);
	
	exports.default = IconList;
	module.exports = exports['default'];

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(83);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Column = __webpack_require__(14);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var More = function More(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'more' },
	    _react2.default.createElement(
	      'div',
	      { className: 'small title' },
	      _react2.default.createElement(
	        'div',
	        { className: 'small left' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          props.title
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        props.largeTitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'small content' },
	      _react2.default.createElement(
	        _Column2.default,
	        { right: true },
	        _react2.default.createElement(_Content2.default, { src: props.content })
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    ),
	    _react2.default.createElement(_Button2.default, { text: props.buttonText, page: props.buttonLink })
	  );
	};
	
	exports.default = More;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.AreasPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(37);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _LargeTitle = __webpack_require__(38);
	
	var _LargeTitle2 = _interopRequireDefault(_LargeTitle);
	
	var _Column = __webpack_require__(14);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _IconList = __webpack_require__(97);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _More = __webpack_require__(47);
	
	var _More2 = _interopRequireDefault(_More);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AreasPageTemplate = exports.AreasPageTemplate = function AreasPageTemplate(_ref) {
	  var title = _ref.title,
	      heroImage = _ref.heroImage,
	      footerImage = _ref.footerImage,
	      intro = _ref.intro,
	      iconList = _ref.iconList,
	      more = _ref.more,
	      meta = _ref.meta;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta.description })
	    ),
	    _react2.default.createElement(_Hero2.default, { image: heroImage }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_LargeTitle2.default, {
	        smallTitle: intro.subtitle,
	        title: intro.title,
	        largeTitle: intro.largeTitle,
	        marginTop: true
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'small content' },
	        _react2.default.createElement(
	          _Column2.default,
	          { left: true },
	          _react2.default.createElement(_Content2.default, { src: intro.leftColumn })
	        ),
	        _react2.default.createElement(
	          _Column2.default,
	          { right: true },
	          _react2.default.createElement(_Content2.default, { src: intro.rightColumn })
	        ),
	        _react2.default.createElement('div', { className: 'clear' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'column left' },
	          _react2.default.createElement(_IconList2.default, { iconList: iconList.left })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column right' },
	          _react2.default.createElement(_IconList2.default, { iconList: iconList.right })
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      )
	    ),
	    _react2.default.createElement(_More2.default, {
	      largeTitle: more.largeTitle,
	      title: more.title,
	      content: more.content,
	      buttonText: more.buttonText,
	      buttonLink: more.buttonLink
	    }),
	    _react2.default.createElement(_Hero2.default, { image: footerImage, footer: true })
	  );
	};
	
	var AreasPage = function AreasPage(_ref2) {
	  var page = _ref2.data.page;
	  return _react2.default.createElement(AreasPageTemplate, _extends({}, page, page.frontmatter, { body: page.html }));
	};
	
	exports.default = AreasPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-areas-page-js-f21fb83b46613a36dd40.js